// extracted by mini-css-extract-plugin
module.exports = {"root":"c6e8ba5398--root--1dLHs","row":"c6e8ba5398--row--1wxxf","price":"c6e8ba5398--price--dhSDS"};